import ExcelJS from "exceljs";

// import ExcelJS from "exceljs/dist/es5/exceljs.browser";
// const ExcelJS = require('exceljs');

import { saveAs } from "file-saver";
import { Moment } from "moment";
// import {
//   asyncActionStart,
//   asyncActionFinish,
//   asyncActionError,
// } from "../../features/async/asyncActions";
// import { closeModal } from "../../features/modals/modalActions";

export const generateSalesTotalsCell = (
  worksheet,
  columnLetter,
  totalDataRows,
  firstDataRow
) => {
  //   const firstDataRow = 11;
  const lastDataRow = firstDataRow + totalDataRows - 1;

  const firstCellReference = `${columnLetter}${firstDataRow}`;
  const lastCellReference = `${columnLetter}${lastDataRow}`;
  const sumRange = `${firstCellReference}:${lastCellReference}`;

  return {
    formula: `SUM(${sumRange})`,
  };
};

export const createNewExcelFile = async (
  reportName,
  transactions,
  worksheetCallback,
  merchantName
) => {
  let workbook = new ExcelJS.Workbook();

  console.log("reportName", reportName);

  workbook.creator = "PrepaidPlus";
  workbook.created = new Date();
  workbook.modified = new Date();

  workbook.views = [
    {
      x: 0,
      y: 0,
      firstSheet: 0,
      activeTab: 0,
      width: 10000,
      height: 20000,
      visibility: "visible",
      // showGridLines: false,
    },
  ];

  // let logoURL = "logo.png";
  // let file = await fetch(logoURL)
  //   .then(r => r.blob())
  //   .then(blobFile => new File([blobFile], "logo", { type: "image/png" }));

  // let logoBase64File = await getBase64(file);

  var myBase64Image =
    "data:image/png;base64,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";
  let logo = workbook.addImage({
    base64: myBase64Image,
    extension: "png",
  });

  const now = Date.now();

  await worksheetCallback(transactions, workbook, logo, merchantName);

  workbook.xlsx
    .writeBuffer()
    .then((data) => {
      const blob = new Blob([data], { type: "application/octet-stream" });
      saveAs(blob, `${reportName}-${now}.xlsx`);
    })
    .catch(function (error) {
      console.log(error.stack);
    });
};

export const createReportExcelFile = async (
  reportName: string,
  transactions: any,
  worksheetCallback: any,
  merchantName: any,
  reportStartDate: Moment,
  reportEndDate: Moment
) => {
  try {
    // dispatch(asyncActionStart());

    console.log("createReportExcelFile reportName", reportName);
    let workbook = new ExcelJS.Workbook();

    workbook.creator = "PrepaidPlus";
    workbook.created = new Date();
    workbook.modified = new Date();

    workbook.views = [
      {
        x: 0,
        y: 0,
        firstSheet: 0,
        activeTab: 0,
        width: 10000,
        height: 20000,
        visibility: "visible",
      },
    ];

    var myBase64Image =
      "data:image/png;base64,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";
    let logo = workbook.addImage({
      base64: myBase64Image,
      extension: "png",
    });

    const now = Date.now();

    await worksheetCallback(
      transactions,
      workbook,
      logo,
      reportStartDate,
      reportEndDate,
      merchantName
    );

    workbook.xlsx
      .writeBuffer()
      .then((data) => {
        const blob = new Blob([data], { type: "application/octet-stream" });
        saveAs(blob, `${reportName}-${now}.xlsx`);
      })
      .catch(function (error) {
        console.log(error.stack);
      });

    // dispatch(closeModal());

    // dispatch(asyncActionFinish());
  } catch (error) {
    if (error) {
      console.log(error);
    }
    // dispatch(closeModal());
    // dispatch(asyncActionError());
  }
};

const getBase64 = (file, onLoadCallback) => {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function () {
      console.log("reader.result", reader.result);
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};
